module.exports = "/assets/images/nabijeci-stanice.e33e11d0.png";